<div>
    <form>
        <div id="{{streetNumberID}}">
            <ng-input [(ng-model)]="addr.streetNumber" id="intStreetNumberInput_{{streetNumberID}}"
                  [(ng-error)]="error_streetNumber"  (blur)="onStreetNumber()"
                  [ng-disable]="notEditable"
                  size="10" max="10" 
                  alt-text="contact_info_and_mailing_address.streetNumber_alt">
                  {{'contact_info_and_mailing_address.streetNumber'}}</ng-input>
        </div>
        <div id="{{streetNameID}}">
            <ng-input [(ng-model)]="addr.streetName" id="intStreetNameInput_{{streetNameID}}"
                  [(ng-error)]="error_streetName"
                  [ng-disable]="notEditable"
                  size="30" max="60" 
                  alt-text="contact_info_and_mailing_address.streetName_alt">
                  {{'contact_info_and_mailing_address.streetName'}}</ng-input>
        </div>
        <div id="{{unitID}}">
            <ng-input [(ng-model)]="addr.unit" id="intUnitInput_{{unitID}}"
                  [(ng-error)]="error_unit" 
                  [ng-disable]="addr.chk_unitNA || notEditable" 
                  size="5" max="5" 
                  alt-text="contact_info_and_mailing_address.unitNumber_alt">
                  {{'contact_info_and_mailing_address.unitNumber'}}</ng-input>
            <ng-checkbox [(ng-model)]="addr.chk_unitNA" [ng-disable]="notEditable" (change)="addr.unit=''; error_unit = ''">
                  {{'contact_info_and_mailing_address.notApplicable'}}</ng-checkbox>
        </div>    
        <div id="{{poboxID}}">
            <ng-input [(ng-model)]="addr.poBox" id="intPoBoxInput_{{poboxID}}"
                  [(ng-error)]="error_poBox" 
                  [ng-disable]="addr.chk_poBox || notEditable"
                  size="20" max="20" 
                  alt-text="contact_info_and_mailing_address.intPobox_alt">
                  {{'contact_info_and_mailing_address.intPobox'}}</ng-input>
            <ng-checkbox [(ng-model)]="addr.chk_poBox" [ng-disable]="notEditable"  (change)="addr.poBox=''; error_poBox = ''">
                  {{'contact_info_and_mailing_address.notApplicable'}}</ng-checkbox>
        </div>
        <div id="{{cityID}}">
            <ng-input [(ng-model)]="addr.base.city" id="intCityTownInput_{{cityID}}"
                  [ng-disable]="notEditable"
                  [(ng-error)]="error_city" 
                  size="20" max="50" 
                  alt-text="contact_info_and_mailing_address.cityTown_alt">
                  {{'contact_info_and_mailing_address.cityTown'}}</ng-input>
        </div>
        <div id="{{provinceID}}">
            <ng-input [(ng-model)]="addr.base.province" id="intProvinceInput_{{provinceID}}"
                  [(ng-error)]="error_province" 
                  [ng-disable]="addr.base.chk_province || notEditable"
                  size="30" max="50" 
                  alt-text="contact_info_and_mailing_address.intProvince_alt">
                  {{'contact_info_and_mailing_address.intProvince'}}</ng-input>
            <ng-checkbox [(ng-model)]="addr.base.chk_province" [ng-disable]="notEditable"  (change)="addr.base.province=''; error_province = ''">
                {{'contact_info_and_mailing_address.notApplicable'}}</ng-checkbox>
        </div>
        <div id="{{countryID}}">
            <ng-select [item-list]="items.isoCountryList" id="intCountrySelect_{{countryID}}"
                  [(ng-model)]="addr.base.country" 
                  [ng-disable]="notEditable"
                  [(ng-error)]="error_country" 
                  size="18">{{'contact_info_and_mailing_address.country'}}</ng-select>
        </div>
        <div id="{{otherCountryID}}" translate [hidden]="addr.base.country!='-1'">
            <h3 translate>{{'contact_info_and_mailing_address.otherCountry'}}</h3>
            <div translate>{{'contact_info_and_mailing_address.otherCountryDesc'}}</div>
            <div [innerHTML]="'contact_info_and_mailing_address.otherCountryNote'|translate"></div>
            <ng-input [(ng-model)]="addr.base.otherCountry" id="intOtherCountryInput_{{otherCountryID}}"
                      [ng-disable]="notEditable"
                        [(ng-error)]="error_otherCountry" 
                        size="30" max="40" 
                        alt-text="contact_info_and_mailing_address.otherCountry_alt"></ng-input>
        </div>
        <div id="int_{{countryID}}">
        <ng-input [(ng-model)]="addr.postalCode" id="intPostalZIPCountryCodeInput_{{countryID}}"
                  [(ng-error)]="error_postal" 
                  [ng-disable]="notEditable"
                  size="20" max="20" 
                  alt-text="contact_info_and_mailing_address.intPostalZIPCountryCode_alt">
                  {{'contact_info_and_mailing_address.intPostalZIPCountryCode'}}</ng-input>
        </div>
       
    </form>
</div>
